import { expandSelectChoices } from './selectChoices';

/**
 * Build toggle filter options for gender / civil_status (B3).
 *
 * Prefer schema choices that can match current persona values, then any
 * extra distinct values. If there is no schema, use distinct values only
 * (same idea as multiselect). Never offer a schema-only option that cannot
 * match any persona when persona data is present.
 */

function normalizeText(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function extractSchemaChoices(fieldKey, schemaAttributes, normalizeKey = (k) => k) {
  if (!Array.isArray(schemaAttributes) || !schemaAttributes.length) return null;

  const target = normalizeKey(fieldKey);
  const attr = schemaAttributes.find(
    (item) => item && normalizeKey(item.key) === target,
  );
  if (!attr) return null;

  const raw = attr.options?.choices ?? (Array.isArray(attr.options) ? attr.options : null);
  if (!Array.isArray(raw) || !raw.length) return null;

  return expandSelectChoices(raw);
}

export function mergeToggleOptions(schemaChoices, distinctValues) {
  const distinct = Array.isArray(distinctValues) ? distinctValues : [];
  const schema = Array.isArray(schemaChoices) ? schemaChoices : [];

  if (!schema.length) {
    return [...distinct];
  }

  if (!distinct.length) {
    return [...schema];
  }

  const distinctByNorm = new Map();
  distinct.forEach((value) => {
    const norm = normalizeText(value);
    if (norm && !distinctByNorm.has(norm)) {
      distinctByNorm.set(norm, value);
    }
  });

  const resolved = [];
  const used = new Set();

  schema.forEach((choice) => {
    const norm = normalizeText(choice);
    if (!norm || used.has(norm)) return;
    if (distinctByNorm.has(norm)) {
      resolved.push(choice);
      used.add(norm);
    }
  });

  distinct.forEach((value) => {
    const norm = normalizeText(value);
    if (!norm || used.has(norm)) return;
    resolved.push(value);
    used.add(norm);
  });

  return resolved;
}
